import React, { useEffect } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { translationsLogbookEventClearState } from 'reducers/translations/logbookEvent/reducer'
import LogbookEventList from './LogbookEventList'
import LogbookEventItem from './LogbookEventItem'

function LogbookEvent(props) {
  const {
    match: {
      params: { id },
    },
    translationsLogbookEventClearState,
  } = props
  const LogbookEventContent = id ? LogbookEventItem : LogbookEventList

  useEffect(
    () => () => {
      translationsLogbookEventClearState()
    },
    [],
  )

  return (
    <div className="content">
      <LogbookEventContent {...props} />
    </div>
  )
}

LogbookEvent.propTypes = {
  match: PropTypes.shape({
    params: PropTypes.shape({
      id: PropTypes.string,
    }),
  }).isRequired,
  translationsLogbookEventClearState: PropTypes.func.isRequired,
}

export default connect(null, {
  translationsLogbookEventClearState,
})(LogbookEvent)
